import { Injectable } from '@angular/core';
import { ConfigApi } from '../../config-api';
import Auth from '@aws-amplify/auth';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PortalService {
  constructor(private http: HttpClient, public api: ConfigApi) {
  }
  private myData: string[] = [];
  getTokenBI = () => this.http.get(this.api.GET_TOKENPOWERBI);

  getReportesPBI = () => this.http.get(this.api.GET_REPORTESPOWERBI);

  getPedidos = (date, todate, client) => {
    const dateStr = [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-');
    const toDate = [todate.getFullYear(), todate.getMonth() + 1, todate.getDate()].join('-');

    const specialClients = {
      29874975: `${this.api.PEDIDOS_URL}${dateStr}&fechaHasta=${toDate}&cliente=29874,29875,97`,
      default: `${this.api.PEDIDOS_URL}${dateStr}&fechaHasta=${toDate}&cliente=${client}`
    };
    return this.http.get(specialClients[client] || specialClients.default);
  }

  getUser = async () => {
    const user = await Auth.currentAuthenticatedUser();
    const { attributes } = user;
    return attributes;
  }

  getMenu = () => this.http.get(this.api.BACKEND_URL);
  getData$(): Observable<string[]> {
    //if we already got the data, just return that
    if (this.myData.length > 0) {
      return of(this.myData);
    }

    //if not, get the data
    return this.http.get<string[]>(this.api.BACKEND_URL)
      .pipe(data => {
        return data
      });
  }


  getIconCliente = (id) => {
    if (id !== undefined) {
      const url = `${this.api.GETICONCLIENTE}${id}.png`;
      // console.log('url logos->', url);
      return url;
    }
  }

  getPicking = (pais , date, todate, client, clientTipo_wms, numPage, filtroBuscar, arrayFechas, arrayEstados) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log('timeZone => ', timeZone); 

    let fromDate = [date.year(), date.month() + 1, date.date()].join('-');
    let toDate = [todate.year(), todate.month() + 1, todate.date()].join('-');

    fromDate = (pais == 'EL SALVADOR')? fromDate : toDate;

    const specialClients = {
      29874975: `${this.api.GETPICKING}29874,29875,97?fecha=${fromDate}&fechaFin=${toDate}${clientTipo_wms && clientTipo_wms !== '' ? `&clientTipo_wms=${clientTipo_wms}` : ''}&numPage=${numPage}&filtroBuscar=${filtroBuscar}${arrayFechas !== '' ? arrayFechas : ''}${arrayEstados !== '' ? arrayEstados : ''}`,
      default: `${this.api.GETPICKING}${client}?fecha=${fromDate}&fechaFin=${toDate}${clientTipo_wms && clientTipo_wms !== '' ? `&clientTipo_wms=${clientTipo_wms}` : ''}&numPage=${numPage}&timeZone=${timeZone}&filtroBuscar=${filtroBuscar}${arrayFechas !== '' ? arrayFechas : ''}${arrayEstados !== '' ? arrayEstados : ''}`
    };
    console.log('specialClients.default => ', specialClients.default);
    return this.http.get(specialClients[client] || specialClients.default);
  }

  getMonitorPedidos = (date, todate, client, numPage, fBuscar, fEstados) => {
    const dateStr = [date.year(), date.month() + 1, date.date()].join('-');
    const toDate = [todate.year(), todate.month() + 1, todate.date()].join('-');

    const url = `${this.api.GET_PEDIDOSMONITOR}?cliente=${client}&fecha=${dateStr}&fechaFin=${toDate}&numPage=${numPage}&fBuscar=${fBuscar}&fEstados=${fEstados}`;
    return this.http.get(url);
  }

  sendMonitorPedidos = (arrayParadas) => {
    const url = `${this.api.SEND_PEDIDOSMONITOR}`;
    const body = {paradas: arrayParadas};
    return this.http.post(url,body);
  }

  exportPicking = (pais , date, todate, client, clientTipo_wms, exportId, filtroBuscar, arrayFechas, arrayEstados) => {

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log('timeZone => ', timeZone); 

    let fromDate = [date.year(), date.month() + 1, date.date()].join('-');
    let toDate = [todate.year(), todate.month() + 1, todate.date()].join('-');

    fromDate = (pais == 'EL SALVADOR')? fromDate : toDate;

    const specialClients = {
      29874975: `${this.api.EXPORTPICKING}29874,29875,97?fecha=${fromDate}&fechaFin=${toDate}${clientTipo_wms && clientTipo_wms !== '' ? `&clientTipo_wms=${clientTipo_wms}` : ''}&filtroBuscar=${filtroBuscar}${arrayFechas !== '' ? arrayFechas : ''}${arrayEstados !== '' ? arrayEstados : ''}`,
      default: `${this.api.EXPORTPICKING}cliente=${client}&timeZone=${timeZone}&fecha=${fromDate}&fechaFin=${toDate}&exportId=${exportId}${clientTipo_wms && clientTipo_wms !== '' ? `&clientTipo_wms=${clientTipo_wms}` : ''}&filtroBuscar=${filtroBuscar}${arrayFechas !== '' ? arrayFechas : ''}${arrayEstados !== '' ? arrayEstados : ''}`
    };
    return this.http.get(specialClients[client] || specialClients.default);
  }

  getDescargas = () => this.http.get(this.api.GET_DESCARGAS);

  getDescargaURL = (key) => {
    const url = `${this.api.GET_DESCARGAURL}key=${key}`;
    return this.http.get(url);
  }

  validateLogin = (module, cliente) => {
    const device = window.innerWidth<=768 ? 'mobile' : 'pc';
    const url = `${this.api.VALIDATE_LOGIN}module=${module}&cliente=${cliente}&device=${device}`;
    return this.http.get(url);
  }

  setPais = (pais, username, userpool) => {
    const url = `${this.api.VALIDATE_LOGIN}setPais=${pais}&userName=${username}&userPool=${userpool}`;
    return this.http.get(url);
  }

  getCheckpoints = (client) => {
    const specialClients = {
      29874975: `${this.api.GENERALORDER_URL}?cliente=29874,29875,97`,
      default: `${this.api.GENERALORDER_URL}?cliente=${client}`
    };
    return this.http.get(specialClients[client] || specialClients.default);
  }

  getLastUpdateHour = () => this.http.get(this.api.LASTUPDATEDHOUR);

  getDetailsOrder = (date, todate, client) => {
    const dateStr = [date.year(), date.month() + 1, date.date()].join('-');
    const toDate = [todate.year(), todate.month() + 1, todate.date()].join('-');
    const specialClients = {
      29874975: `${this.api.DETAILORDER_URL}fecha=${dateStr}&fechaHasta=${toDate}&cliente=29874,29875,97,29897`,
      default: `${this.api.DETAILORDER_URL}fecha=${dateStr}&fechaHasta=${toDate}&cliente=${client}`
    };
    return this.http.get(specialClients[client] || specialClients.default);
  }

  exportExcel = (date, todate, client, reg, filtroBuscar, filtroEstado, filtroServicio, filtroOperacion) => {
    const dateStr = [date.year(), date.month() + 1, date.date()].join('-');
    const toDate = [todate.year(), todate.month() + 1, todate.date()].join('-');
    const specialClients = {
      29874975: `${this.api.EXPORTEXCEL}fecha=${dateStr}&fechaHasta=${toDate}&cliente=29874,29875,97,29897&oldFBuscar=${filtroBuscar}&oldFEstado=${filtroEstado}&oldFServicio=${filtroServicio}&oldFOperacion=${filtroOperacion}`,
      default: `${this.api.EXPORTEXCEL}fecha=${dateStr}&fechaHasta=${toDate}&cliente=${client}&oldFBuscar=${filtroBuscar}&oldFEstado=${filtroEstado}&oldFServicio=${filtroServicio}&oldFOperacion=${filtroOperacion}`
    };
    return this.http.get(specialClients[client] || specialClients.default);
  }


  getListaOrder = (dateStr, toDate, client) => {


    const specialClients = {
      29874975: `${this.api.LISTAPEDIDOS_URL}fecha=${dateStr}&fechaHasta=${toDate}&cliente=29874,29875,97`,
      default: `${this.api.LISTAPEDIDOS_URL}fecha=${dateStr}&fechaHasta=${toDate}&cliente=${client}`
    };
    return this.http.get(specialClients[client] || specialClients.default);
  }

  getCitasPorHora = (date, todate, client) => {
    const dateStr = [date.year(), date.month() + 1, date.date()].join('-');
    const toDate = [todate.year(), todate.month() + 1, todate.date()].join('-');

    const specialClients = {
      29874975: `${this.api.CITAS_POR_HORA_URL}cliente=29874,29875,97&fechaInicio=${dateStr}&fechaFin=${toDate}`,
      default: `${this.api.CITAS_POR_HORA_URL}cliente=${client}&fechaInicio=${dateStr}&fechaFin=${toDate}`
    };
    return this.http.get(specialClients[client] || specialClients.default);
  }

  getDetailPicking = (pat, client, clientTipo_wms) => {
    const url = `${this.api.GETDETAILPICKING}${pat}?cliente=${client}${clientTipo_wms && clientTipo_wms !== '' ? `&clientTipo_wms=${clientTipo_wms}` : ''}`;
    return this.http.get(url);
  }
  getViajeporFecha = (date, client ) => {

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log('timeZone => ', timeZone); 

    const dateStr = [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-');
    const url = `${this.api.GET_VIAJEPORFECHA}${dateStr}&cliente=${client}&timeZone=${timeZone}`;
    return this.http.get(url);
  }

  getDetailViaje = (date, client, idViaje) => {
    const dateStr = [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-');
    const url = `${this.api.DETAILORDER_URL}fecha=${dateStr}&cliente=${client}&idViaje=${idViaje}`;
    return this.http.get(url);
  }

  getTemperature = (placa, viaje, ambiente, client, fecha) => {
    const url = `${this.api.GET_TEMPERATURE}${viaje}?ambiente=${ambiente}&origen=web&cod_cliente=${client}&fecha=${fecha}&placa=${placa}`;
    return this.http.get(url);
  }

  getPaginacion = (date, todate, client, reg, nroPag, filtroBuscar, filtroEstado, filtroServicio, filtroOperacion, pageSize, ArrayfiltroEstado, ArrayfiltroServicio, ArrayfiltroOperacion, email) => {
    const dateStr = [date.year(), date.month() + 1, date.date()].join('-');
    const toDate = [todate.year(), todate.month() + 1, todate.date()].join('-');
    const url = `${this.api.GET_PAGINACION}${dateStr}&correo=${email}&fechaHasta=${toDate}&cliente=${client}&pagina=${nroPag}&oldFBuscar=${filtroBuscar}&oldFEstado=${filtroEstado}&oldFServicio=${filtroServicio}&oldFOperacion=${filtroOperacion}&pageSize=${pageSize}${ArrayfiltroEstado}${ArrayfiltroServicio}${ArrayfiltroOperacion}`;
    console.log('URL => ', url)
    return this.http.get(url, reg);
  }

  getPaginacionTCF = (date, todate, client, reg, nroPag, filtroBuscar, filtroEstado, filtroServicio, filtroOperacion, pageSize, ArrayfiltroEstado, ArrayfiltroServicio, ArrayfiltroOperacion, email) => {
    const dateStr = [date.year(), date.month() + 1, date.date()].join('-');
    const toDate = [todate.year(), todate.month() + 1, todate.date()].join('-');
    const url = `${this.api.GET_PAGINACION_TCF}${dateStr}&correo=${email}&fechaHasta=${toDate}&cliente=${client}&pagina=${nroPag}&oldFBuscar=${filtroBuscar}&oldFEstado=${filtroEstado}&oldFServicio=${filtroServicio}&oldFOperacion=${filtroOperacion}&pageSize=${pageSize}${ArrayfiltroEstado}${ArrayfiltroServicio}${ArrayfiltroOperacion}`;
    console.log('URL_TCF => ', url)
    return this.http.get(url, reg);
  }

  getDtImportacion = (startDate: Date, endDate: Date, client: string, rucAgenteAduana: string) => {
    const startDateInt = [startDate.getFullYear(), `${startDate.getMonth() + 1}`.padStart(2, '0'), `${startDate.getDate()}`.padStart(2, '0')].join('');
    const endDateInt = [endDate.getFullYear(), `${endDate.getMonth() + 1}`.padStart(2, '0'), `${endDate.getDate()}`.padStart(2, '0')].join('');
    const url = `${this.api.DT_TRACKING}/dtImportacion?fechaInicio=${startDateInt}&fechaFin=${endDateInt}&codCliente=${client}&rucAgenteAduana=${rucAgenteAduana}`;
    return this.http.get(url);
  }

  getDtImportacionDet = (numeroOrdenServicio, numeroBl) => {
    const url = `${this.api.DT_TRACKING}/dtImportacionDet?ordenServicio=${numeroOrdenServicio}&numeroBl=${numeroBl}`;
    return this.http.get(url);
  }

  getDtImportacionCheckpoint = (ordenServicio, numeroBl, numeroCorrelativo) => {
    const url = `${this.api.DT_TRACKING}/dtImportacionCheckpoint?ordenServicio=${ordenServicio}&numeroBl=${numeroBl}&numeroCorrelativo=${numeroCorrelativo}`;
    return this.http.get(url);
  }

  getDtExportacion = (startDate: Date, endDate: Date, codCliente: string, rucAgenteAduana: string) => {
    const startDateInt = [startDate.getFullYear(), `${startDate.getMonth() + 1}`.padStart(2, '0'), `${startDate.getDate()}`.padStart(2, '0')].join('');
    const endDateInt = [endDate.getFullYear(), `${endDate.getMonth() + 1}`.padStart(2, '0'), `${endDate.getDate()}`.padStart(2, '0')].join('');
    const url = `${this.api.DT_TRACKING}/dtExportacion?fechaInicio=${startDateInt}&fechaFin=${endDateInt}&codCliente=${codCliente}&rucAgenteAduana=${rucAgenteAduana}`;
    return this.http.get(url);
  }

  getApiListarUser = (urlGet, body) => {
    const url = `${this.api.GET_USER}${urlGet}`;
    return this.http.post(url, body);
  }

  getFotoPorParada = (parada ) => {
    return this.http.get(`${this.api.GET_FOTOPORPARADA}paradas=${parada}`);
  }

  getApiUser = (urlGet) => {
    const url = `${this.api.GET_USER}${urlGet}`;
    return this.http.get(url);
  }

  postCrearUser = (body) => {
    return this.http.post(`${this.api.GET_USER}/configuracionUsuario/crearUsuario`, body);
  }

  postEditarUser = (body) => {
    return this.http.put(`${this.api.GET_USER}/configuracionUsuario/editarUsuario`, body);
  }

  postEliminarUser = (correo) => {
    return this.http.put(`${this.api.GET_USER}/configuracionUsuario/eliminarUsuario?username=${correo}`, '');
  }
  
  editarColumnasPersonalizadas = (cliente, usuario, body) => {
    return this.http.post(`${this.api.EDITAR_COLUMNAS_AVANCE}?cliente=${cliente}&usuario=${usuario}`, body);
  }

  listarColumnasPersonalizadas = (cliente, usuario) => {
    return this.http.get(`${this.api.LISTAR_COLUMNAS_AVANCE}?cliente=${cliente}&usuario=${usuario}`);
  }

  getDtExportacionDet = (numeroOrdenServicio, numeroBooking) => {
    const url = `${this.api.DT_TRACKING}/dtExportacionDet?ordenServicio=${numeroOrdenServicio}&numeroBooking=${numeroBooking}`;
    return this.http.get(url);
  }

  getDtExportacionCheckpoint = (ordenServicio, numeroBooking, numeroGuiaIngreso) => {
    const url = `${this.api.DT_TRACKING}/dtExportacionCheckpoint?ordenServicio=${ordenServicio}&numeroBooking=${numeroBooking}&numeroGuiaIngreso=${numeroGuiaIngreso}`;
    return this.http.get(url);
  }

  
  getAsbancConsultaFacPendiente = (body, numPage, fFactura , fGlosa, fEstado, fRangoEstado, fFechaIni, fFechaFin, fMoneda, pSize) => {
    const url = `${this.api.GET_ASBANCCONSULTAFACPENDIENTE}?numPage=${numPage}&pSize=${pSize}${fFactura !== '' ? `&filtroFactura=${fFactura}` : ''}${fGlosa !== '' ? `&filtroGlosa=${fGlosa}` : ''}${fEstado !== '' ? fEstado : ''}${fRangoEstado !== '' ? fRangoEstado : ''}${fFechaIni !== '' ? `&filtroFechaIni=${fFechaIni}` : ''}${fFechaFin !== '' ? `&filtroFechaFin=${fFechaFin}` : ''}${fMoneda !== '' ? fMoneda : ''}`;
    return this.http.post(url, body);
    // return of(DATA_BACK)
    //        .pipe(
    //         delay(1000)
    //        );
  }

  postGenerarCodigoPago = (body) => {
    // console.log(`Body de Generacion: ${JSON.stringify(body)}`)
    const url = `${this.api.POST_ASBANCGENERARCODIGO}`;
    return this.http.post(url, body);
    // return of({ codigo_generado: '100', fecha_vigencia: '22/09/2022', hora_vigencia: '15:05 a.m.' })
    //        .pipe(
    //         delay(2000)
    //        );
  }

  getAsbancConsultaCodigoPago = (body) => {
    const url = `${this.api.GET_ASBANCCONSULTACODIGOPAGO}`;
    return this.http.post(url, body);
    // return of(CODIGO_PAGO_BACKEND)
    //        .pipe(
    //         delay(2000)
    //        );
  }

  exportDocPorPagar = (client, exportId, fFactura , fGlosa, fEstado, fRangoEstado, fFechaIni, fFechaFin) => {
    const specialClients = {
      default: `${this.api.EXPORT_DOC_POR_PAGAR}cliente=${client}&exportId=${exportId}${fFactura !== '' ? `&filtroFactura=${fFactura}` : ''}${fGlosa !== '' ? `&filtroGlosa=${fGlosa}` : ''}${fEstado !== '' ? fEstado : ''}${fRangoEstado !== '' ? fRangoEstado : ''}${fFechaIni !== '' ? `&filtroFechaIni=${fFechaIni}` : ''}${fFechaFin !== '' ? `&filtroFechaFin=${fFechaFin}` : ''}`
    };
    return this.http.get(specialClients.default);
  }

  getAsbancFacAbonadas = (client, fFactura, fCodPago, fGlosa, fFechaIni, pSize, numPage, pagoKey, sapKey, fMoneda) => { // fFechaFin
    const specialClients = {
      default: `${this.api.GET_ASBANC_CONSULTA_FAC_ABONADAS}?filtroNroFactura=${fFactura}&filtroNroPago=${fCodPago}&filtroGlosa=${fGlosa}&filtroFechaIni=${fFechaIni}&pSize=${pSize}&numPage= ${numPage}&codigo_pagoKey=${pagoKey}&codigo_cliente_sapKey=${sapKey}&filtroMoneda=${fMoneda}`
    };
    return this.http.post(specialClients.default, { cliente: client});
  }

  getAsbancCodPagoVigentes = (client, fCodPago, fFecha) => {
    const specialClients = {
      default: `${this.api.GET_ASBANC_CONSULTA_COD_VIGENTES}?filtroNroPago=${fCodPago}&filtroFechaIni=${fFecha}&filtroFechaFin=${fFecha}`
    };
    return this.http.post(specialClients.default, { cliente: client});
  }

  getAsbancDetalleFac = (client, fCodPago) => {
    const specialClients = {
      default: `${this.api.GET_ASBANC_CONSULTA_FAC_DETALLES}?filtroNroPago=${fCodPago}`
    };
    return this.http.post(specialClients.default, { cliente: client});
  }

  getAsbancDeleteCodPago = (fCodPago, cod_cliente_sap) => {
    const specialClients = {
      default: `${this.api.GET_ASBANC_DELETE_COD_PAGO}?codPagoVigente=${fCodPago}&cod_cliente_sap=${cod_cliente_sap}`
    };
    return this.http.post(specialClients.default, {});
  }

  getAsbancFacPdfXml = (ruc, tipoDoc, factura, tipoRetorno) => {
    const specialClients = {
      default: `${this.api.GET_ASBANC_FAC_PDF_XML}?ruc=${ruc}&tipoDoc=${tipoDoc}&factura=${factura}&tipoRetorno=${tipoRetorno}`
    };
    return this.http.post(specialClients.default, {});
  }

  exportFacAbonadas = (cliente, exportId, fNroFactura, fNroPago, fGlosa, fFechaIni) => {
    const specialClients = {
      default: `${this.api.GET_ASBANC_FAC_ABONADAS}?cliente=${cliente}&exportId=${exportId}&filtroNroFactura=${fNroFactura}&filtroNroPago=${fNroPago}&filtroGlosa=${fGlosa}&filtroFechaIni=${fFechaIni}`
    };
    return this.http.get(specialClients.default);
  }
  
  exportCodPagoVigente = (cliente, exportId, fCodPago, fFecha) => {
    const specialClients = {
      default: `${this.api.GET_ASBANC_COD_PAGO_VIGENTE}?cliente=${cliente}&exportId=${exportId}&filtroCodPago=${fCodPago}&filtroFecha=${fFecha}`
    };
    return this.http.get(specialClients.default);
  }
  

  getInventarioResumen = (client, almacen) => {
    const specialClients = {
      default: `${this.api.GET_RESUMEN_INVENTARIO}?cliente=${client}&almacen=${almacen}`
    };
    return this.http.get(specialClients.default);
  }   

  getInventarioStock = (client, pagina, arrayFiltro, ArrayColumnasText, codigoFilter, descripcionFilter, stockFilter, estadosFilter, familiaFilter, almacen) => {
    const specialClients = {
      default: `${this.api.GET_LISTA_STOCK_INVENTARIO}?cliente=${client}&almacen=${almacen}&codigoFilter=${codigoFilter}&descripcionFilter=${descripcionFilter}&pagina=${pagina}${arrayFiltro}${ArrayColumnasText}${stockFilter}${estadosFilter}${familiaFilter}`
    };
    console.log('getInventarioStock > ', specialClients.default);
    return this.http.get(specialClients.default);
  }

  getInventarioSku = (client, pagina, arrayFiltro, ArrayColumnasText, codigoFilter, descripcionFilter, almacen) => {
    const specialClients = {
      default: `${this.api.GET_LISTA_SKU_INVENTARIO}?cliente=${client}&almacen=${almacen}&codigoFilter=${codigoFilter}&descripcionFilter=${descripcionFilter}&pagina=${pagina}${arrayFiltro}${ArrayColumnasText}`
    };
    return this.http.get(specialClients.default);
  }

  getDetalleSku = (client, SKU, ArrayColumnasText, almacen) => {
    const specialClients = {
      default: `${this.api.GET_DETALLE_SKU_INVENTARIO}?cliente=${client}&almacen=${almacen}&codSku=${SKU}${ArrayColumnasText}`
    };
    return this.http.get(specialClients.default);
  }

  LoadDaraInventarios = (client) => {
    const specialClients = {
      default: `${this.api.REPROCESAR_INVENTARIO}?cliente=${client}`
    };
    return this.http.get(specialClients.default);
  }

  exportInventario = (client, exportId,  codigoFilter, descripcionFilter, stockFilter, estadosFilter, familiaFilter, ArrayColumnasText) => {
    const specialClients = {
      29874975: `${this.api.EXPORTINVENTARIO}29874,29875,97`,
      default: `${this.api.EXPORTINVENTARIO}cliente=${client}&exportId=${exportId}&codigoFilter=${codigoFilter}&descripcionFilter=${descripcionFilter}${ArrayColumnasText}${stockFilter}${estadosFilter}${familiaFilter}`
    };
    return this.http.get(specialClients[client] || specialClients.default);
  }

  exportInventarioSku = (client, exportId, maestro, ArrayColumnasText, codigoFilter, descripcionFilter) => {
    const specialClients = {
      29874975: `${this.api.EXPORTINVENTARIOSKU}29874,29875,97`,
      default: `${this.api.EXPORTINVENTARIOSKU}cliente=${client}&exportId=${exportId}&codigoFilter=${codigoFilter}&descripcionFilter=${descripcionFilter}&correo=${maestro}${ArrayColumnasText}`
    };
    console.log('specialClients.default => ', specialClients.default);
    return this.http.get(specialClients[client] || specialClients.default);
  }

  getCliente = (numPage, filBuscar, ArrayPais, pagSize) => {
    return this.http.get(`${this.api.GET_CLIENTE}listar?pagina=${numPage}${filBuscar !== '' ? `&fCliente=${filBuscar.toUpperCase()}` : ''}&pageSize=${pagSize}${ArrayPais}`);
  }

  getClientePadre = (cli) => {
    const specialClients = {
      default: `${this.api.GET_CLIENTE}listar?fClientePadre=${cli}`
    };
    return this.http.get(specialClients.default);
  }

  getDetalleCliente = (codCli) => {
    const specialClients = {
      default: `${this.api.GET_CLIENTE}listar?fClienteDetalle=${codCli}`
    };
    return this.http.get(specialClients.default);
  }
  
  editCliente = (body) => {
    return this.http.post(`${this.api.GET_CLIENTE}editar`, body);
  }

  postEliminarCliente = (idCliente) => {
    return this.http.put(`${this.api.GET_CLIENTE}eliminar?id_cliente=${idCliente}`, '');
  }

  postNewCliente = (body) => {
    return this.http.post(`${this.api.GET_CLIENTE}nuevo`, body);
  }
  
  getConsultaViajesActivos = (fechaInicio: Date, fechaFin: Date) => {
    const url = `${this.api.CONSULTA_VIAJE}/consultaViajesActivos?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
    console.log(url)
    return this.http.get(url);
  }
}
